import { render } from "./Trazabilidad.vue?vue&type=template&id=30410cbd"
import script from "./Trazabilidad.vue?vue&type=script&lang=js"
export * from "./Trazabilidad.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__